import { Box, Skeleton, styled, Typography } from "@mui/material";

import { useBillingBalanceQuery } from "Billing/Api/Queries/useBillingBalanceQuery";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Price } from "Shared/Price/Price";

const CardWrapper = styled(Box)`
  background: ${(props) => props.theme.colors.backgroundTile};
  border: 1px solid ${(props) => props.theme.colors.border};
  border-radius: ${Radius.M};
  padding: ${(props) => props.theme.spacing(Spacing.M)};
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing(Spacing.XS)};
`;

export const BalanceCard = (): React.ReactNode => {
  const { t } = useResource();
  const { data, isLoading } = useBillingBalanceQuery();

  return (
    <CardWrapper>
      <Typography variant="body2" color="text.secondary">
        {t(Resources.Billing.CurrentBalance)}
      </Typography>
      {isLoading ? (
        <Skeleton variant="text" width={180} height={48} />
      ) : (
        <Typography
          variant="h1"
          sx={(theme) => ({
            color: theme.palette.common.white,
            fontSize: 36,
            fontWeight: 700,
          })}
        >
          <Price amount={data?.balance ?? 0} />
        </Typography>
      )}
    </CardWrapper>
  );
};
